import { InstanceScreen } from 'component/navigation/instance';

export default function VideoVotingEditScreen() {
    return <InstanceScreen screenKey='edit' />;
}
